module.exports = __webpack_public_path__ + "static/media/Spoonerism-MT-4.ff8fdf0e.mp3";